import { all } from "redux-saga/effects";

// Action types
import * as types from "../actionTypes/services.types";

// Constants
import * as filtersTypes from "../../constants/services.constants";

// Actions
import {
  getServicesSuccess,
  getMoreServicesSuccess,
  openTicketDetailsSuccess,
  cancelServiceSuccess,
  startServiceSuccess,
  pauseServiceSuccess,
  resumeServiceSuccess,
  finishServiceSuccess,
  updateServiceSuccess,
  getScheduleSuccess,
  getUnassignedScheduleSuccess
} from "../actions/services.actions";

// Calls
import {
  fetchServicesRequest,
  fetchServiceDetailsRequest,
  cancelServiceRequest,
  startServiceRequest,
  pauseServiceRequest,
  resumeServiceRequest,
  finishServiceRequest,
  updateServiceRequest,
  fetchWorkersScheduleRequest
} from "../../api/calls/services.call";

import { fetchSaga } from "./fetch.saga";

const servicesArgs = a => [
  a.dateFilter,
  a.groupQuery,
  a.searchQuery,
  a.limit,
  a.lastService,
  a.sortBy
];

export default function* servicesSaga() {
  yield all([
    fetchSaga({
      trigger: types.FETCH_SERVICES_REQUEST,
      apiCall: fetchServicesRequest,
      args: servicesArgs,
      onSuccess: r => getServicesSuccess(r.services, r.pagination),
      failedType: types.FETCH_SERVICES_FAILED
    })(),
    fetchSaga({
      trigger: types.FETCH_MORE_SERVICES_REQUEST,
      apiCall: fetchServicesRequest,
      args: servicesArgs,
      onSuccess: r => getMoreServicesSuccess(r.services, r.pagination),
      failedType: types.FETCH_MORE_SERVICES_FAILED
    })(),
    fetchSaga({
      trigger: types.OPEN_SERVICE_DETAILS,
      apiCall: fetchServiceDetailsRequest,
      args: a => [a.serviceId, a.branchId],
      onSuccess: r => openTicketDetailsSuccess(r.service),
      failedType: types.OPEN_SERVICE_DETAILS_FAILED
    })(),
    fetchSaga({
      trigger: types.CANCEL_SERVICE_REQUEST,
      apiCall: cancelServiceRequest,
      args: a => [a.serviceId],
      onSuccess: r => cancelServiceSuccess(r.message),
      failedType: types.CANCEL_SERVICE_FAILED
    })(),
    fetchSaga({
      trigger: types.START_SERVICE_REQUEST,
      apiCall: startServiceRequest,
      args: a => [a.serviceId, a.branchId],
      onSuccess: r => startServiceSuccess(r.message),
      failedType: types.START_SERVICE_FAILED
    })(),
    fetchSaga({
      trigger: types.PAUSE_SERVICE_REQUEST,
      apiCall: pauseServiceRequest,
      args: a => [a.serviceId],
      onSuccess: r => pauseServiceSuccess(r.message),
      failedType: types.PAUSE_SERVICE_FAILED
    })(),
    fetchSaga({
      trigger: types.RESUME_SERVICE_REQUEST,
      apiCall: resumeServiceRequest,
      args: a => [a.serviceId],
      onSuccess: r => resumeServiceSuccess(r.message),
      failedType: types.RESUME_SERVICE_FAILED
    })(),
    fetchSaga({
      trigger: types.FINISH_SERVICE_REQUEST,
      apiCall: finishServiceRequest,
      args: a => [a.serviceId],
      onSuccess: r => finishServiceSuccess(r.message),
      failedType: types.FINISH_SERVICE_FAILED
    })(),
    fetchSaga({
      trigger: types.UPDATE_SERVICE_REQUEST,
      apiCall: updateServiceRequest,
      args: a => [a.formValues, a.serviceId],
      onSuccess: r => updateServiceSuccess(r.service),
      failedType: types.UPDATE_SERVICE_FAILED
    })(),
    // SCHEDULE
    fetchSaga({
      trigger: types.FETCH_EMPLOYEES_SCHEDULE_REQUESTS,
      apiCall: fetchWorkersScheduleRequest,
      args: a => [a.dateQuery, a.includedStatuses, a.chosenEmployees],
      onSuccess: r => getScheduleSuccess(r.employees, r.workDay),
      failedType: types.FETCH_EMPLOYEES_SCHEDULE_FAILED
    })(),
    // Unassigned services for the schedule (rendered as draggable rows on top
    // of the worker grid). Reuses the generic /services endpoint with
    // `statuses[]=unassigned` and a single-day date filter.
    fetchSaga({
      trigger: types.FETCH_UNASSIGNED_SCHEDULE_REQUEST,
      apiCall: fetchServicesRequest,
      args: a => [
        { enabled: true, from: a.dateQuery, to: a.dateQuery },
        [filtersTypes.FILTERS_UNASIGNED],
        undefined,
        200,
        undefined,
        undefined
      ],
      onSuccess: r => getUnassignedScheduleSuccess(r.services),
      failedType: types.FETCH_UNASSIGNED_SCHEDULE_FAILED
    })()
  ]);
}
